export default "__VITE_PUBLIC_ASSET__b51bd0d5__"